'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ResetPasswordController = function () {
    /* @ngInject */
    function ResetPasswordController($scope, ApiAuthentication, $state, localStorageService, $ionicPopup, $filter) {
        _classCallCheck(this, ResetPasswordController);

        this.ApiAuthentication = ApiAuthentication;
        this.$state = $state;
        this.localStorageService = localStorageService;
        this.$ionicPopup = $ionicPopup;
        this.translate = $filter('translate');

        // Prerequisites
        this.user = {};
    }

    _createClass(ResetPasswordController, [{
        key: 'passwordForgotten',
        value: function passwordForgotten() {
            var _this = this;

            var user = this.user;
            this.ApiAuthentication.initiatePasswordReset(user.email).then(function (res) {
                if (res !== undefined) {
                    var alertPopup = _this.$ionicPopup.alert({
                        title: _this.translate('CHECK_EMAIL'),
                        template: _this.translate('RESET_PASSWORD_MSG')
                    });

                    alertPopup.then(function (res) {
                        _this.$state.go('login');
                    });
                }
            });
        }
    }]);

    return ResetPasswordController;
}();

exports.default = ResetPasswordController;


/** WEBPACK FOOTER **
 ** ./src/app/components/user/resetPassword.controller.js
 **/